'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _pageActions = require('../actions/page-actions');

var _pageActions2 = _interopRequireDefault(_pageActions);

var _loaders = require('../utils/loaders');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_pageState = require('../reducers/page-reducers').babelPluginFlowReactPropTypes_proptype_pageState || require('react').PropTypes.any;

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);

var messages = void 0;
try {
    messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
    messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

/**
 loaders
 **/

var errorPageLoader = new _doctifyUtils.PageLoader(_loaders.loaders);

var ErrorPage = function ErrorPage(props) {
    props.init(props);
    return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeBase, messages: messages },
        _react2.default.createElement(
            'div',
            {
                className: 'container',
                style: { paddingTop: props.app.headerHeight }
            },
            _react2.default.createElement(
                'h1',
                null,
                'Error'
            ),
            _react2.default.createElement(
                'p',
                null,
                props.page.errorMessage
            )
        )
    );
};

ErrorPage.propTypes = {
    page: babelPluginFlowReactPropTypes_proptype_pageState,
    app: require('react').PropTypes.object.isRequired
};
ErrorPage.displayName = 'ErrorPage';

var mapStateToProps = function mapStateToProps(state) {
    return {
        app: state.global.app,
        page: state.errorPage.page
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        pageActions: (0, _redux.bindActionCreators)(_pageActions2.default, dispatch),
        init: function init(props) {
            if (typeof window !== 'undefined') {
                var params = props.location && props.location.query && {
                    _errorMessage_: props.location.query.errorMessage,
                    _errorCode_: props.location.query.errorCode
                } || {};
                errorPageLoader.runOnce(dispatch, props, null, params).then(function (isFirstLoad) {
                    if (isFirstLoad) {
                        props.pageActions.loadedUri();
                    }
                });
            }
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ErrorPage);


// WEBPACK FOOTER //
// ./components/error-page/lib/components/error-page.js